/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Injectable } from '@angular/core';
import { ApiEntity } from 'app/api/models/api-entity.model';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { DataService } from 'app/shared/services/data.service';
@Injectable({ providedIn: 'root' })
export class BookingConfirmationDesignDetailService extends DataService<any> {
	constructor(apiDependencies: ApiDependenciesService) {
		super(apiDependencies);
	}

	//#region endpoints

	getBookingConfirmationDesignPreviewViewEndpoint(itemId: number): string {
		return '/booking-confirmation-designs' + '/' + itemId + '/preview';
	}
	//#endregion

	async getBookingConfirmationDesignPreviewView(itemId?: number, eventId?: number): Promise<ApiEntity> {
		let model: ApiEntity;
		let endpoint: string;
		if (!itemId) {
			endpoint = '/booking-confirmation-designs/blank/preview';
		} else {
			endpoint = this.getBookingConfirmationDesignPreviewViewEndpoint(itemId);
		}

		if (eventId) {
			endpoint = `/events/${eventId}` + endpoint;
		}
		await this.setEndpoint(endpoint)
			.getSingle()
			.then((response: any) => {
				model = response;
			});
		return Promise.resolve(model);
	}
}
